import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { resolveTopLevelDomain } from './shared/util/deploy-helper';

const REGISTRY_HEADER = 'X-Microservice-Registry';

@Injectable()
export class MicroserviceRegistryInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      !environment.injectMicroserviceRegistryHeader ||
      request.headers.has(REGISTRY_HEADER) ||
      !this.isInstallationReportingRequest(request.url)
    ) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          [REGISTRY_HEADER]: this.countryCode(),
        },
      }),
    );
  }

  private isInstallationReportingRequest(url: string): boolean {
    if (url.includes('/installation-reporting-backend')) {
      return true;
    }
    const bases = [
      environment.installationReportingApiUrl,
      environment.installationReportingApiV2Url,
      environment.installationReportingApiV3Url,
    ];
    return bases.some((base) => base && url.startsWith(base));
  }

  private countryCode(): string {
    return resolveTopLevelDomain();
  }
}
